import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import Tippy from "@tippy.js/react";
import "tippy.js/dist/tippy.css";
import {
  addCapex,
  reorderCapex,
  getCapexCost,
} from "../../store/entities/capex";
import add from "../../images/plusButtonBlue.png";
import addGrey from "../../images/add-grey.png";
import { Container } from "./costsStyling";
import { generateRandomId, handleSendCapex, nextIndexOfGroup, numberToCurrency } from "../../helpers";
import CapexRow from "./capexRow";
import { getSelectedProject } from "../../store/user";
import question from "../../images/qMark.png";

function CapexInfo() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const capex = state.entities.capex.data;
  const leader = state.user.selectedLeader;
  const { maxCapex } = useSelector(getSelectedProject);
  const total = getCapexCost(state)[leader];
  const formattedCost = numberToCurrency(total);
  // console.log(totals);
  const combined = leader === "combined";
  const group = combined
    ? capex
    : capex.filter((item) => item.leader === leader);

  function handleAddCapex() {
    const position = nextIndexOfGroup(group, capex);
    const newCapex = {
      leader,
      capexId: generateRandomId('capex'),
      condition: "New",
      description: "New capex",
      depreciation: 1,
      currentValue: 1,
      residualValue: 1,
      utilisation: 1,
    };
    dispatch(addCapex({ newCapex, position }));
  }

  function handleMovingRow(result) {
    if (!result.destination || result.destination.index === result.source.index)
      return;
    const movement = result.destination.index - result.source.index;
    const capex = group[result.source.index];
    dispatch(reorderCapex({ capex, movement }));
    handleSendCapex()
  }

  return (
    <Container>
      <div className="materials">
        <div className="row titles leaderTabMargin">
          <p className="title materialsDescription">Description</p>
          {/* <p className="title small left">Condition</p> */}
          <div className="title small left">
            <p className="">Condition</p>
            <Tippy content="Select whether this capital item will be a new purchase or your organisation already owns it">
              <div className="info">
                <img src={question} alt="add" />
              </div>
            </Tippy>
          </div>
          <div className="title small depreciation">
            <p className="">Depreciation</p>
            <Tippy content="Depreciation Period (months)">
              <div className="image">
                <img src={question} alt="info" />
              </div>
            </Tippy>
          </div>
          <div className="title small">
            <p className="">Value</p>
            <Tippy content="Current Value">
              <div className="image">
                <img src={question} alt="info" />
              </div>
            </Tippy>
          </div>
          <div className="title small">
            <p className="">Residual</p>
            <Tippy content="Residual Value">
              <div className="image">
                <img src={question} alt="info" />
              </div>
            </Tippy>
          </div>
          <div className="title small">
            <p className="">Utilisation</p>
            <Tippy content="Utilisation %">
              <div className="image">
                <img src={question} alt="info" />
              </div>
            </Tippy>
          </div>
          <p className="title small">Total</p>
        </div>
        <div className="rows">
          <DragDropContext onDragEnd={handleMovingRow}>
            <Droppable droppableId="capex">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {group.map((capex, index) => {
                    return (
                      <Draggable
                        key={capex.capexId}
                        draggableId={capex.capexId}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            className="MonthContainer packBackground"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                          >
                            <CapexRow
                              provided={provided}
                              index={index}
                              key={index}
                              capex={capex}
                            />
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="row">
            {combined ? null : group.length >= maxCapex ? (
              <Tippy content={`Maximum ${maxCapex}`}>
                <button className="addIcon">
                  <img src={addGrey} alt="add" />
                </button>
              </Tippy>
            ) : (
              <Tippy content="Add capex item">
                <button className="addIcon" onClick={handleAddCapex}>
                  <img src={add} alt="add" />
                </button>
              </Tippy>
            )}
            {group.length > 0 ? (
              <>
                <p className="title small" />
                <p className="title materialsDescription" />
                <p className="title small depreciation" />
                <p className="title small" />
                <p className="title small" />
                <p className="title small" />
                <div className="total">
                  <p className="field display small">£{formattedCost}</p>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </Container>
  );
}
export default CapexInfo;
